import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AppPage from "@/pages/AppPage";
import AppsPage from "@/pages/AppsPage";
import PlsExplorer from "@/pages/PlsExplorer";
import BrandKit from "@/pages/BrandKit";
import BundlesPage from "@/pages/BundlesPage";
import EmailSignature from "@/pages/EmailSignature";

const Landing = () => (
  <>
    <SmoothScroll />
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <About />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/app" element={<AppPage />} />
          <Route path="/apps" element={<AppsPage />} />
          <Route path="/apps/pls" element={<PlsExplorer />} />
          <Route path="/apps/brand" element={<BrandKit />} />
          <Route path="/apps/bundles" element={<BundlesPage />} />
          <Route path="/signature" element={<EmailSignature />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
